/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:11
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-06 16:49:15
 */
import { createFromJSON } from "./help.js"
import { GraphElement } from "../graph-element.js"
import Konva from "konva"

class PCSElement extends GraphElement {
  static fromJSON = createFromJSON(this)
  constructor(topology, x, y) {
    super(topology, 'pcs', x, y, {
      text: '逆变器',
      port: true
    })
    this.onLoad(() => {
      this.addArrowDown()
      this.addArrowUp()

      // TODO: 演示状态切换,待删除
      this.__randomState()
    })

    this.pcsState = 0   //0:停止  1:AC->DC  2:DC->AC
  }

  addArrowUp() {
    this.arrowUp = new Konva.Arrow({
      x: 40,
      y: 28,
      points: [0, 28, 0, 0],
      pointerLength: 6,
      pointerWidth: 6,
      fill: 'white',
      stroke: 'white',
      strokeWidth: 3,
      dash: [4, 2],
    })

    this.g.add(this.arrowUp)
  }
  addArrowDown() {
    this.arrowDown = new Konva.Arrow({
      x: 24,
      y: 25,
      points: [0, 0, 0, 28],
      pointerLength: 6,
      pointerWidth: 6,
      fill: 'white',
      stroke: 'white',
      strokeWidth: 3,
      dash: [4, 2],
    })
    this.g.add(this.arrowDown)
  }

  updatePCSState(state) {
    this.pcsState = state

    if (state == 0) {
      this.arrowUp.dash([4, 2])
      this.arrowDown.dash([4, 2])
    }
    else if (state == 1) {
      this.arrowUp.dash([4, 2])
      this.arrowDown.dash([])
    }
    else if (state == 2) {
      this.arrowUp.dash([])
      this.arrowDown.dash([4, 2])
    }
  }

  // TODO： 待删除代码
  __randomState() {
    this.__t = setInterval(() => {
      let s = Math.floor(Math.random() * 3)
      this.updatePCSState(s)
    }, 2000)

    this.onRemove(() => {
      clearInterval(this.__t)
    })
  }
}



export { PCSElement }
